type TransportKindDetails = {
  mainTransportMode?: string
  mainTransportType?: string
}

export const isAirShipment = (details: TransportKindDetails): boolean => details.mainTransportMode === 'air'

/** LCL shipments, air included since air is always LCL, move packages rather than containers of their own. */
export const isLCLShipment = (details: TransportKindDetails): boolean =>
  isAirShipment(details) || details.mainTransportType === 'lcl'
